import { writable, get, derived } from "svelte/store";
import cbor from 'cbor-web';
import { localKeyHandle } from "../Utilities/keys";
const initialWallet = { state: 'disconnected', bridge: null, balance: null };
export const wallet = writable(initialWallet, (set) => {
    const handle = localStorage.getItem(localKeyHandle);
    if (handle) {
        _connect().then(set);
    }
    else {
        set(initialWallet);
    }
});
export const disconnect = writable(false);
disconnect.subscribe(() => wallet.update(() => initialWallet));
export const balance = derived(wallet, (w, set) => {
    if (w === null || w === void 0 ? void 0 : w.bridge) {
        w.bridge.getBalance().then(set);
    }
    else {
        set(null);
    }
});
class Eternl {
    constructor(raw) {
        this.raw = raw;
    }
    async getBalance() {
        var _a, _b, _c;
        const w = get(wallet);
        const now = new Date();
        if (((_a = w === null || w === void 0 ? void 0 : w.balance) === null || _a === void 0 ? void 0 : _a.value) && (now.valueOf() - w.balance.lastUpdate.valueOf()) < 5000) {
            return w.balance.value;
        }
        const response = await this.raw.getBalance();
        const [decoded] = await cbor.decodeAll(response);
        const balance = {
            lovelace: BigInt(decoded[0]),
            assets: {}
        };
        for (const [policy, map] of decoded[1].entries()) {
            for (const [assetName, amount] of map.entries()) {
                const p = policy.toString('hex');
                const n = assetName.toString('hex');
                balance.assets[p] = (_b = balance.assets[p]) !== null && _b !== void 0 ? _b : {};
                balance.assets[p][n] = (_c = balance.assets[p][n]) !== null && _c !== void 0 ? _c : BigInt(0);
                balance.assets[p][n] += BigInt(amount);
            }
        }
        wallet.update(w => (Object.assign(Object.assign({}, w), { balance: { value: balance, lastUpdate: now } })));
        return balance;
    }
}
function eternl() {
    let cardano = window.cardano;
    return cardano.eternl;
}
export async function _connect() {
    let raw = await eternl().enable();
    const bridge = new Eternl(raw);
    return { state: 'connected', bridge, balance: null };
}
export async function connect() {
    if (eternl() == null) {
        console.log("no eternl detected");
    }
    wallet.update(w => (Object.assign(Object.assign({}, w), { state: 'connecting' })));
    const newWallet = await _connect();
    wallet.update(w => {
        return Object.assign(Object.assign({}, w), newWallet);
    });
}
export default wallet;
